'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import PropTypes from 'prop-types';

var ErrorList = function ErrorList() {
  return _react2.default.createElement('div', null)
  // <div className={classNames}>
  //   {errors.map((error, i) => (
  //     <li key={`elt_${i}`}>
  //       {error.stack}
  //     </li>
  //       ))}
  // </div>
  ;
};

ErrorList.defaultProps = {
  // classNames: '',
};

ErrorList.propTypes = {
  // classNames: PropTypes.string,
  // errors: PropTypes.array.isRequired,
};

exports.default = ErrorList;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Form/FieldTemplates/ErrorList/index.js
// module id = 1029
// module chunks = 0